import { render, staticRenderFns } from "./ExistingDocumentEditor.vue?vue&type=template&id=652eae0d&scoped=true&"
import script from "./ExistingDocumentEditor.vue?vue&type=script&lang=ts&"
export * from "./ExistingDocumentEditor.vue?vue&type=script&lang=ts&"
import style0 from "./ExistingDocumentEditor.vue?vue&type=style&index=0&id=652eae0d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652eae0d",
  null
  
)

export default component.exports